import React, { PureComponent } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { checkSession } from '../../actions'
import { fetchHowToDocumentation, fetchClientSupportDocuments } from '../../actions/how_to_documentation'
import { DivContentBox, DivTitleBox } from '../../components/common/styled'
import './styles.css'
import HowToGuides from '../../components/documentation/how_to_guides'
import ComplianceIcon from '../../components/documentation/icons/compliance-icon.svg'
import SoftwareDevelopers from '../../components/documentation/software_developers'
import { getFileExtension } from '../../utils/filters'
import Spinner3Bounce from '../businesses'
import { pdfjs, Page, Document } from 'react-pdf'
// this is workaround https://github.com/wojtekmaj/react-pdf/wiki/Known-issues
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

export class Documentation extends PureComponent {
  state = {
    file: '',
    numPages: null,
    pageNumber: 1,
  }

  onDocumentLoad = ({ numPages }) => {
    this.setState({ numPages })
  }

  openPdf = (file) => this.setState({ file })

  open = (file) => window.open(file, '_blank')

  componentDidMount() {
    this.props.fetchHowToDocumentation()
    this.props.fetchClientSupportDocuments()
  }

  getDocumentsByTag = (tag) => {
    if (this.props.documentation && this.props.documentation.results) {
      const documents = this.props.documentation.results.filter((d) => d.tags.includes(tag))
      documents.sort((a, b) => (a.sorting > b.sorting ? 1 : b.sorting > a.sorting ? -1 : 0))
      return documents
    } else {
      return []
    }
  }

  render() {
    const { state, props } = this
    const { isAuthenticated, isFetching, response } = props
    if (!isAuthenticated) {
      return null
    }

    if (isFetching) {
      return (
        <div className='text-center grid-spinner-mt-240'>
          <Spinner3Bounce isActive />
        </div>
      )
    }

    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        {state.file && (
          <Modal size={'lg'} show onHide={() => this.setState({ file: '' })}>
            <Modal.Header closeButton>
              <Modal.Title>Document</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Document file={state.file} onLoadSuccess={this.onDocumentLoad}>
                {Array.from(new Array(state.numPages), (el, index) => (
                  <Page width={800} key={`page_${index + 1}`} pageNumber={index + 1} />
                ))}
              </Document>
              <div>
                {state.numPages && (
                  <p>
                    Page {state.pageNumber} of {state.numPages}
                  </p>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='default' onClick={() => this.setState({ file: '' })}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        <DivTitleBox className='ibox-title'>
          <div className='row'>
            <div className='col-xs-12 col-sm-12'>
              <h2>KYC Information Portal</h2>
            </div>
          </div>
        </DivTitleBox>
        <DivContentBox className='ibox-content documentation'>
          <div className='documentation-row'>
            <div className={'documentation-block'}>
              <div className={'documentation-block-title'}>
                <div className={'documentation-block-title__icon'}>
                  <img src={ComplianceIcon} alt='' />
                </div>
                <h2>Compliance Officers</h2>
              </div>
              <div className={'documentation-block-list'}>
                {this.getDocumentsByTag('Compliance Officers').map((document, index) => (
                  <div key={index} className={'documentation-block-list-item'}>
                    <i className='fa fa-file-pdf-o fa-2x' aria-hidden='true' />
                    <a href={document.file} target={'_blank'} rel='noreferrer'>
                      {' '}
                      {document.title}
                    </a>
                    <span className={'documentation-block-list-actions'}>
                      <i className='fa fa-download' aria-hidden='true' onClick={() => this.open(document.file)} />
                      {getFileExtension(document.file) === 'pdf' && (
                        <i className='fa fa-eye' aria-hidden='true' onClick={() => this.openPdf(document.file)} />
                      )}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <SoftwareDevelopers documents={this.getDocumentsByTag('Software Developers')} />
          </div>
          {response && <HowToGuides results={this.getDocumentsByTag('How-To Guides')} />}
        </DivContentBox>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: state.auth.isAuthenticated,
  isFetching: state.fetchClientSupportDocuments.isFetching,
  response: state.fetchHowToDocumentation.response,
  documentation: state.fetchClientSupportDocuments.response,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      checkSession,
      fetchHowToDocumentation: fetchHowToDocumentation,
      fetchClientSupportDocuments: fetchClientSupportDocuments,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Documentation))
